import React, { useState, lazy } from "react";
import LegendItem from "./LegendItem.jsx";

//only load VinylLegends component for pages that need it e.g  !singletType
const VinylLegends = lazy(() => import("./VinylLegends.jsx"));

const Legends = ({
  singleType,
  legend,
  pageOptions,
  onOptionClick,
  selectedPocketType,
  clickCount
}) => {

const [legends,setLegends] = useState(legend);

  return (
    <div className="legend-grid-container">
      <div className="row">
        <div className="col-xs-12 legendRow">
          <div className="legendBox col-md-2">
            <a href={legends[0].URL}>
              {legends[0].DisplayName.toUpperCase().replace(" SIGN", "")}
            </a>
          </div>

         { (singleType === true && legends !== null) && (
            <div className="legended-sign-panel-container col-md-10">
              {legends.map((item, index) => {
                return (
                  <LegendItem
                    legendItem={item}
                    key={item.ProductSubGroupID}
                    singleType={singleType}
                    index={index}
                    pageOptions={pageOptions}
                    selectedPocketType={selectedPocketType}
                    clickCount={clickCount}
                  />
                );
              })}
            </div>
          )}
          {(singleType === false) && (
            <VinylLegends
              vinylLegends={legends}
              pageOptions={pageOptions}
              onOptionClick={onOptionClick}
              selectedPocketType={selectedPocketType}
              clickCount={clickCount}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Legends;
